import React from "react";
import PropTypes from "prop-types";

import Fieldset from "../../common/Fieldset";
import TextAreaInput from "../../common/TextAreaInput";
import FieldsetSubHeader from "../../common/FieldsetSubHeader";


const InnovatieForm = (props) => {
	const {
		beoordelingscriteria,
		disabled,
		errors,
		onChange,
		validationMessageType
	} = props;

	const INNOVATIE_TOOLTIP = "Niet alle innovatie eigeneschappen zijn verplicht om een hoge score te behalen op het criterium innovatie. Sommige vragen kunnen bijgevolg niet van toepassing zijn voor jouw project.";
	return (
		<Fieldset title="Innovatie" tooltip={INNOVATIE_TOOLTIP} tooltipWindowWidth={25}>
			<p style={{ fontSize: '17px', fontWeight: 'bold', marginLeft: '.83333%' }}>Toekomstvisie</p>
			&nbsp;
			<FieldsetSubHeader>Hoe zie je de invulling & uitbating van uw sportaccommodatie binnen 20 jaar rekening houdend met volgende megatrends: bevolkingsgroei & verstedelijking, multiculturaliteit, technologische adoptie, vergrijzing, klimaatsverandering.</FieldsetSubHeader>
			<TextAreaInput
				name="invullingenUitbatingBinnen20Jaar"
				label="invulling en uitbating binnen 20 jaar"
				value={beoordelingscriteria.invullingenUitbatingBinnen20Jaar}
				onChange={onChange}
				size={12}
				height={4}
				disabled={disabled}
				tooltip={"In 2040 zijn we met 1 miljoen Belgen meer. Hoe zou je de bezettingsgraad efficiënt kunnen verhogen? Hoe ga je diversiteit in sport gaan brengen zowel naar aanbod, organisatie, aanpak, accommodatie… Welk effect zullen autonome voertuigen, virtual reality, Augmented reality, wearables, data, artificiële intelligentie…hebben op sport en hoe zullen ze een rol spelen in onze sportaccommodaties? Toename van CO2 in de lucht zorgt niet alleen voor slechtere luchtkwaliteit maar ook voor klimaatopwarming met extreme regenval of droogtes, overstromingen,... tot gevolg. Hoe zou je er kunnen voor zorgen dat uw accommodaties nog duurzamer wordt en de impact op het klimaat zo klein mogelijk of zelfs positief wordt?"}
				validationMessage={errors ? errors.invullingenUitbatingBinnen20Jaar : ''}
				validationMessageType={validationMessageType}
				maxLength={2000} />
			<FieldsetSubHeader>Welke stappen heb je in dit project nu al gezet in de richting van deze toekomstvisie?</FieldsetSubHeader>
			<TextAreaInput
				name="stappenRichtingToekomstvisie"
				label="stappen richting toekomstvisie"
				value={beoordelingscriteria.stappenRichtingToekomstvisie}
				onChange={onChange}
				size={12}
				height={4}
				disabled={disabled}
				tooltip={"Denk hierbij bijvoorbeeld aan innovaties rond de thema’s technologie,  exploitatie, duurzaamheid, energie, ecologie, maatschappelijke innovatie, sporttechnische innovatie, samenwerking of andere innovaties"}
				validationMessage={errors ? errors.stappenRichtingToekomstvisie : ''}
				validationMessageType={validationMessageType}
				maxLength={2000} />
			<FieldsetSubHeader>Toon aan in welke mate je aandacht hebt geschonken aan zuinig ruimtegebruik.</FieldsetSubHeader>
			<TextAreaInput
				name="aandachtZuinigRuimtegebruik"
				label="aandacht voor zuinig ruimtegebruik"
				value={beoordelingscriteria.aandachtZuinigRuimtegebruik}
				onChange={onChange}
				size={12}
				height={4}
				disabled={disabled}
				tooltip={"Elke dag wordt er in Vlaanderen bijkomend 6 ha open ruimte ingenomen voor nieuwe ontwikkelingen. De open ruimte dreigt in snel tempo te verdwijnen. Daarom zet Vlaanderen sterk in op zuinig ruimtegebruik, op het verhogen van het “ruimtelijk rendement”.Dit betekent: meer doen met dezelfde ruimte volgens volgende principes: intensiveren, hergebruik van ruimte, verweven van functies, tijdelijk ruimtegebruik,…Een aantal voorbeelden: verdichten, in de hoogte bouwen, ondergrondse ruimten voorzien, delen van parkings/ruimtes/faciliteiten, … (intensiveren), opnemen in het project van verlaten loodsen, kerken,... (hergebruik), ..."}
				validationMessage={errors ? errors.aandachtZuinigRuimtegebruik : ''}
				validationMessageType={validationMessageType}
				maxLength={2000} />
			<p style={{ fontSize: '17px', fontWeight: 'bold', marginLeft: '.83333%' }}>Sportparticipatie</p>
			&nbsp;
			<FieldsetSubHeader>Welke innovaties in dit project zorgen ervoor dat: er meer mensen zullen sporten, mensen vaker zullen sporten, mensen niet zullen afhaken?</FieldsetSubHeader>
			<TextAreaInput
				name="innovatiesSportparticipatie"
				label="sportparticipatie innovaties"
				value={beoordelingscriteria.innovatiesSportparticipatie}
				onChange={onChange}
				size={12}
				height={4}
				disabled={disabled}
				validationMessage={errors ? errors.innovatiesSportparticipatie : ''}
				validationMessageType={validationMessageType}
				maxLength={2000} />
			<FieldsetSubHeader>Welke ondersteunende diensten en/of producten zullen er worden ingezet om deze doelen te bereiken?</FieldsetSubHeader>
			<TextAreaInput
				name="ondersteunendeDienstenEnProducten"
				label="sportparticipatie ondersteunende diensten en/of producten"
				value={beoordelingscriteria.ondersteunendeDienstenEnProducten}
				onChange={onChange}
				size={12}
				height={4}
				disabled={disabled}
				validationMessage={errors ? errors.ondersteunendeDienstenEnProducten : ''}
				validationMessageType={validationMessageType}
				maxLength={2000} />
		</Fieldset>
	);
};

// ----------------------------------------------------------------------------
InnovatieForm.propTypes = {
	beoordelingscriteria: PropTypes.object.isRequired,
	disabled: PropTypes.bool,
	errors: PropTypes.object,
	onChange: PropTypes.func.isRequired,
	validationMessageType: PropTypes.string
};

export default InnovatieForm;
